// @flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import * as util from "../../util/util";
import ImageSource from "../../source/image_source";
import browser from "../../util/browser";
import StencilMode from "../../gl/stencil_mode";
import DepthMode from "../../gl/depth_mode";
import CullFaceMode from '../../gl/cull_face_mode';
import RenderRaster from "./plotty-render";
import RenderRaster2 from "./plotty-render/render-raster-2";
import { drawGeojsonStencil, checkGeojsonStencil, getMaskTile } from "./draw_geoson_stencil";
import drawStencilImg from "./draw_stencil_img";
import { rasterUniformValues } from "../../render/program/raster_program";
import { endGeojsonStencil } from "./stencil_mode";

import type Painter from "../../render/painter";
import type SourceCache from "../../source/source_cache";
import type RasterStyleLayer from "../../style/style_layer/raster_style_layer";
import type { OverscaledTileID } from "../../source/tile_id";

export default drawLercUtil;
// module.exports = {
//     drawLercUtil,
//     getLercMaskTexture,
//     default: drawLercUtil,
// };

export function drawLercUtil(
    painter: Painter,
    sourceCache: SourceCache,
    layer: RasterStyleLayer,
    coords: Array<OverscaledTileID>,
    { programName = "lerc", bindOtherParamFunc } = {},
) {
    
    if (painter.renderPass !== "translucent") return;
    if (layer.paint.get("raster-opacity") === 0) return;
    // é¿ålercè¢«å¶ä»å¾å±ç Stencil å¹²æ°æ©è
    painter.clearStencil();
    const context = painter.context;
    const gl = context.gl;
    const source = sourceCache.getSource();
    const program = painter.useProgram(programName);
    context.program.set(program.program);

    // Constant parameters.
    // gl.uniform1f(program.uniforms.u_brightness_low, layer.paint.get('raster-brightness-min'));
    // gl.uniform1f(program.uniforms.u_brightness_high, layer.paint.get('raster-brightness-max'));
    // gl.uniform1f(program.uniforms.u_saturation_factor, saturationFactor(layer.paint.get('raster-saturation')));
    // gl.uniform1f(program.uniforms.u_contrast_factor, contrastFactor(layer.paint.get('raster-contrast')));
    // gl.uniform3fv(program.uniforms.u_spin_weights, spinWeights(layer.paint.get('raster-hue-rotate')));
    // gl.uniform1f(program.uniforms.u_buffer_scale, 1);
    // gl.uniform1i(program.uniforms.u_image0, 0);
    // gl.uniform1i(program.uniforms.u_image1, 1);

    // é¢è²å¼å
    gl.uniform1f(program.uniforms.u_domain_max, layer.paint.get("raster-domain-max"));
    gl.uniform1f(program.uniforms.u_domain_min, layer.paint.get("raster-domain-min"));

    // lercä¸ä¸é
    gl.uniform1f(program.uniforms.u_clamp_high, layer.paint.get("lerc-clamp-high"));
    gl.uniform1f(program.uniforms.u_clamp_low, layer.paint.get("lerc-clamp-low"));

    const clampHighValue =
        layer.paint.get("clamp-high-value") !== undefined
            ? layer.paint.get("clamp-high-value")
            : layer.paint.get("raster-domain-max");
    const clampLowValue =
        layer.paint.get("clamp-low-value") !== undefined
            ? layer.paint.get("clamp-low-value")
            : layer.paint.get("raster-domain-min");
    
    let textureScale;

    if(programName === "lerc"){
        /** ä¸ºäºç§é¡¾RenderRasteçæçè¾¹ç¼é¢è² */
        gl.uniform1f(program.uniforms.u_clamp_high_value, clampHighValue + RenderRaster2.colorscaleEageValue);
        gl.uniform1f(program.uniforms.u_clamp_low_value, clampLowValue - RenderRaster2.colorscaleEageValue);
        gl.uniform1i(program.uniforms.u_texture_length, RenderRaster2.textureLength);
    
        const paint: Paint = {
            "raster-colorscale": layer.getPaintProperty("raster-colorscale"),
            "raster-domain-max": layer.paint.get("raster-domain-max"),
            "raster-domain-min": layer.paint.get("raster-domain-min"),
            "clamp-high-value": clampHighValue,
            "clamp-low-value": clampLowValue,
            "lerc-clamp-high": layer.paint.get("lerc-clamp-high"),
            "lerc-clamp-low": layer.paint.get("lerc-clamp-low"),
            "lerc-include": layer.paint.get("lerc-include") || [],
            "lerc-exclude": layer.paint.get("lerc-exclude") || [],
        }
        textureScale = RenderRaster2.bind(context).getTexture(paint);
    }else{
        gl.uniform1f(program.uniforms.u_clamp_high_value, clampHighValue);
        gl.uniform1f(program.uniforms.u_clamp_low_value, clampLowValue);
        const rasterColor = layer.getPaintProperty("raster-colorscale");
        textureScale = RenderRaster.bind(context).getTexture(rasterColor);
    }
    
    bindIncludeAndExclude(gl, program, layer);
    // ç»å®å«çåæ°

    const colorMode = painter.colorModeForRenderPass();
    const lercMaskSourceId = layer.paint.get("lerc-mask-source");
    const geojsonMaskSourceId = layer.paint.get("geojson-mask-source");
    let geojsonMaskSourceOption = {
        roundZoom: false,
        tileSize: 512,
    };
    if (geojsonMaskSourceId) {
        const maskLayer = sourceCache.style.getLayer(geojsonMaskSourceId);
        const maskSource = maskLayer && sourceCache.style.getSource(maskLayer.source);
        if (maskSource) {
            geojsonMaskSourceOption = {
                roundZoom: maskSource.roundZoom,
                tileSize: maskSource.tileSize,
            };
        }
    }

    const minTileZ = coords.length && coords[0].overscaledZ;

    for (const coord of coords) {
        if (textureScale) {
            context.activeTexture.set(gl.TEXTURE2);
            gl.bindTexture(gl.TEXTURE_2D, textureScale);
            gl.uniform1i(program.uniforms.u_textureScale, 2);
        }
        if (bindOtherParamFunc) {
            bindOtherParamFunc(gl, program, layer, sourceCache, coord);
        }
        // set the lower zoom level to sublayer 0, and higher zoom levels to higher sublayers
        // painter.setDepthSublayer(coord.overscaledZ - minTileZ);

        const depthMode = painter.depthModeForSublayer(
            coord.overscaledZ - minTileZ,
            layer.paint.get("raster-opacity") === 1 ? DepthMode.ReadWrite : DepthMode.ReadOnly,
            gl.LESS,
        );
        const tile = sourceCache.getTile(coord);
        const posMatrix = painter.transform.calculatePosMatrix(coord.toUnwrapped());

        tile.registerFadeDuration(layer.paint.get("raster-fade-duration"));

        gl.uniformMatrix4fv(program.uniforms.u_matrix, false, posMatrix);

        const parentTile = sourceCache.findLoadedParent(coord, 0, {}),
            fade = getFadeValues(tile, parentTile, sourceCache, layer, painter.transform);

        let parentScaleBy, parentTL;

        context.activeTexture.set(gl.TEXTURE0);
        // tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);

        // å ä¸ºlerc-image-source ä¸ lerc-source-v2 ç¨çtileä¸åï¼åé¢ä¼å° lerc-source-v2 çtileä¿®æ¹
        gl.bindTexture(gl.TEXTURE_2D, tile.texture);

        context.activeTexture.set(gl.TEXTURE1);

        if (parentTile) {
            // parentTile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
            gl.bindTexture(gl.TEXTURE_2D, parentTile.texture);

            parentScaleBy = Math.pow(2, parentTile.tileID.overscaledZ - tile.tileID.overscaledZ);
            parentTL = [(tile.tileID.canonical.x * parentScaleBy) % 1, (tile.tileID.canonical.y * parentScaleBy) % 1];
        } else {
            // tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
        }

        const uniformValues = rasterUniformValues(posMatrix, parentTL || [0, 0], parentScaleBy || 1, fade, layer);

        const maskSourceId = layer.paint.get("lerc-mask-source");
        const maskTexture = getLercMaskTexture(sourceCache, maskSourceId, coord);
        // å­å¨ maskTexture æ´»ç maskTexture ä¸ºnullçæ¶åè¯´æè¦æ©è
        // maskTexture
        if (lercMaskSourceId) {
            gl.uniform1f(program.uniforms.u_mask, true);
            gl.activeTexture(gl.TEXTURE3);
            gl.bindTexture(gl.TEXTURE_2D, maskTexture);
            gl.uniform1i(program.uniforms.u_texture_mask, 3);
            if (!maskTexture) {
                gl.uniform1i(program.uniforms.u_is_no_mask_texture, true);
            } else {
                gl.uniform1i(program.uniforms.u_is_no_mask_texture, false);
            }
        } else {
            gl.uniform1i(program.uniforms.u_mask, false);
            gl.uniform1i(program.uniforms.u_is_no_mask_texture, true);
        }

        // cross-fade parameters
        gl.uniform2fv(program.uniforms.u_tl_parent, parentTL || [0, 0]);
        gl.uniform1f(program.uniforms.u_scale_parent, parentScaleBy || 1);
        gl.uniform1f(program.uniforms.u_fade_t, fade.mix);
        gl.uniform1f(program.uniforms.u_opacity, fade.opacity * layer.paint.get("raster-opacity"));
        let stencilMode = StencilMode.disabled;

        if (checkGeojsonStencil(painter, sourceCache, layer)) {
            const maskZoom = painter.transform.coveringZoomLevel(geojsonMaskSourceOption);
            let maskCoord = maskZoom < coord.overscaledZ ? coord.scaledTo(maskZoom) : coord;
            const tile = getMaskTile(sourceCache, geojsonMaskSourceId, maskCoord);
            // if (tile) {
            // const source = sourceCache.style.getSource(geojsonMaskSourceId);
            // const maskSourceCache = source && source._eventedParent;

            if (tile) {
                maskCoord = tile.tileID;
            } else {
                continue;
            }
            // }
            if (!maskCoord) {
                continue;
            }
            drawGeojsonStencil(painter, sourceCache, layer, maskCoord, programName);
            // drawGeojsonStencil(painter, sourceCache, layer, coord, programName);
            stencilMode = endGeojsonStencil;
        }

        if (source instanceof ImageSource) {
            if (layer.paint.get("image-geojson-mask") && source.geojsoMask && source.geojsonTexture) {
                drawStencilImg(painter, sourceCache, coord, programName, layer);
                stencilMode = endGeojsonStencil;
            }
            program.draw(
                context,
                gl.TRIANGLES,
                depthMode,
                stencilMode,
                colorMode,
                CullFaceMode.disabled,
                uniformValues,
                layer.id,
                source.boundsBuffer,
                painter.quadTriangleIndexBuffer,
                source.boundsSegments,
            );
        } else if (tile.maskedBoundsBuffer && tile.maskedIndexBuffer && tile.segments) {
            program.draw(
                context,
                gl.TRIANGLES,
                depthMode,
                stencilMode,
                colorMode,
                CullFaceMode.disabled,
                uniformValues,
                layer.id,
                tile.maskedBoundsBuffer,
                tile.maskedIndexBuffer,
                tile.segments,
                layer.paint,
                painter.transform.zoom,
            );
        } else {
            program.draw(
                context,
                gl.TRIANGLES,
                depthMode,
                stencilMode,
                colorMode,
                CullFaceMode.disabled,
                uniformValues,
                layer.id,
                painter.rasterBoundsBuffer,
                painter.quadTriangleIndexBuffer,
                painter.rasterBoundsSegments,
            );
        }
    }
    // context.depthFunc.set(gl.LEQUAL);
    // é¿ålercçStencilå¹²æ°å¶ä»å¾å±
    painter.clearStencil();
}

function getFadeValues(tile, parentTile, sourceCache, layer, transform) {
    const fadeDuration = layer.paint.get("raster-fade-duration");

    if (fadeDuration > 0) {
        const now = browser.now();
        const sinceTile = (now - tile.timeAdded) / fadeDuration;
        const sinceParent = parentTile ? (now - parentTile.timeAdded) / fadeDuration : -1;

        const source = sourceCache.getSource();
        const idealZ = transform.coveringZoomLevel({
            tileSize: source.tileSize,
            roundZoom: source.roundZoom,
        });

        // if no parent or parent is older, fade in; if parent is younger, fade out
        const fadeIn =
            !parentTile ||
            Math.abs(parentTile.tileID.overscaledZ - idealZ) > Math.abs(tile.tileID.overscaledZ - idealZ);

        const childOpacity =
            fadeIn && tile.refreshedUponExpiration ? 1 : util.clamp(fadeIn ? sinceTile : 1 - sinceParent, 0, 1);

        // we don't crossfade tiles that were just refreshed upon expiring:
        // once they're old enough to pass the crossfading threshold
        // (fadeDuration), unset the `refreshedUponExpiration` flag so we don't
        // incorrectly fail to crossfade them when zooming
        if (tile.refreshedUponExpiration && sinceTile >= 1) tile.refreshedUponExpiration = false;

        if (parentTile) {
            return {
                opacity: 1,
                mix: 1 - childOpacity,
            };
        } else {
            return {
                opacity: childOpacity,
                mix: 0,
            };
        }
    } else {
        return {
            opacity: 1,
            mix: 0,
        };
    }
}

function bindIncludeAndExclude(gl, program, layer) {
    const include = layer.paint.get("lerc-include") || [];
    const exclude = layer.paint.get("lerc-exclude") || [];
    const maskInclude = layer.paint.get("lerc-mask-include") || [];
    const maskExclude = layer.paint.get("lerc-mask-exclude") || [];

    gl.uniform1i(program.uniforms.u_include_length, include.length);
    gl.uniform1i(program.uniforms.u_exclude_length, exclude.length);
    gl.uniform1i(program.uniforms.u_mask_include_length, maskInclude.length);
    gl.uniform1i(program.uniforms.u_mask_exclude_length, maskExclude.length);
    
    const u_exclude = gl.getUniformLocation(program.program, "u_exclude");
    const u_include = gl.getUniformLocation(program.program, "u_include");
    const u_mask_include = gl.getUniformLocation(program.program, "u_mask_include");
    const u_mask_exclude = gl.getUniformLocation(program.program, "u_mask_exclude");

    if (include.length > 0 && include[0]) {
        gl.uniform2fv(u_include, include.join().split(","));
    }
    if (exclude.length > 0 && exclude[0]) {
        gl.uniform2fv(u_exclude, exclude.join().split(","));
    }
    if (maskInclude.length > 0 && maskInclude[0]) {
        gl.uniform2fv(u_mask_include, maskInclude.join().split(","));
    }
    if (maskExclude.length > 0 && maskExclude[0]) {
        gl.uniform2fv(u_mask_exclude, maskExclude.join().split(","));
    }
}

export function getLercMaskTexture(sourceCache, maskSourceId, coord) {
    // const maskSourceId = layer.paint['lerc-mask-source'];
    if (!maskSourceId) {
        return undefined;
    }
    const maskSourceCache = sourceCache.style.sourceCaches[maskSourceId];
    if (!maskSourceCache) {
        return undefined;
    }
    const maskTile = maskSourceCache.getTile(coord) || maskSourceCache._cache.data[coord.canonical.key];
    const maskTexture = maskTile && maskTile.texture;
    if (!maskTexture) {
        return null;
    }
    return maskTexture;
}
